import styled from 'styled-components';

const sidebarWidth = '56px';
const Image = styled.img `
  width: ${sidebarWidth};
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export { Image, sidebarWidth };
